import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Verbier",
    desc: "Pose de carrelage à Verbier. Marbre, pierre naturelle, grands formats — on travaille avec des matériaux nobles et on les pose avec la précision d'un artisan qui sait ce qu'il fait.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Verbier",
    desc: "Rénovation de salle de bain à Verbier. Hammam, sauna, baignoire en pierre, robinetterie design — on livre un travail que les clients exigeants reconnaissent au premier coup d'œil.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Verbier",
    desc: "Douche italienne à Verbier. Receveur invisible, paroi panoramique, carrelage XXL, étanchéité liquide. Le luxe, c'est un travail invisible qui ne fuit jamais.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Verbier",
    desc: "Mosaïque et faïence à Verbier. Créations uniques pour des espaces résidentiels hors du commun. Matériaux d'Italie et d'Espagne, posés avec la minutie que ça demande.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur à Verbier",
    desc: "Terrasses et espaces extérieurs à Verbier. Carrelage technique haute résistance au gel et antidérapant. Les conditions extrêmes de haute montagne exigent des matériaux à la hauteur.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Verbier",
      "item": "https://carreaux-bat.ch/verbier"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Verbier, Valais",
  "description": "Pose de carrelage haut de gamme et rénovation de salle de bain à Verbier, station internationale des 4 Vallées. Marbre, mosaïque, douche italienne. Artisan carreleur.",
  "url": "https://carreaux-bat.ch/verbier",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "City",
      "name": "Verbier",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function VerbierPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Verbier à Proximité | 4 Vallées Valais"
        description="Vous cherchez un carreleur à proximité de Verbier ? Entreprise de carrelage et société de carrelage à Verbier, station des 4 Vallées. Service de carrelage haut de gamme par carreleur près de chez vous à Verbier, Nendaz, Veysonnaz, La Tzoumaz. Pose de carrelage, marbre, douche italienne, hammam."
        keywords="carreleur à proximité de Verbier, entreprise de carrelage à proximité de Verbier, société de carrelage à proximité de Verbier, carreleur près de chez moi Verbier, entreprise de carrelage près de chez vous Verbier, service de carrelage à proximité Verbier, entreprise de carrelage Verbier, société de carrelage Verbier, service de carrelage Verbier, carreleur Verbier, pose de carrelage Verbier, rénovation salle de bain Verbier, douche italienne Verbier, carrelage haut de gamme 4 Vallées, marbre Verbier, artisan carreleur station ski Suisse"
        canonical="https://carreaux-bat.ch/verbier"
        ogTitle="Carrelage & Rénovation à Verbier à Proximité — Artisan Carreleur en Station"
        ogDescription="Vous cherchez un carreleur à proximité de Verbier ? Pose de carrelage haut de gamme, rénovation salle de bain et douche italienne à Verbier et dans les 4 Vallées. Discrétion et finitions de précision."
        ogImage="/images/verbier-hero.jpg"
        geoPosition="46.0959;7.2286"
        geoPlacename="Verbier, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/verbier-hero.jpg"
          alt="Carrelage Verbier Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Station Internationale
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Verbier</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Verbier, c'est exigeant. On intervient ici depuis des années pour des clients qui savent reconnaître un joint droit quand ils en voient un.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Verbier</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Verbier, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Verbier, l&apos;élite des Alpes suisses</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Verbier est bien plus qu&apos;une station de ski : c&apos;est un lieu qui attire une clientèle internationale qui connaît le bon travail. Située à 1 500 mètres d&apos;altitude dans les 4 Vallées, la plus grande domaine skiable de Suisse, Verbier attire des visiteurs exigeants qui recherchent de l&apos;authenticité et des expériences uniques en montagne.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Carreleur à Verbier — Pose de carrelage marbre et pierre naturelle</h3>
                <p>
                  Avec environ 3 000 habitants permanents mais une population qui peut dépasser 30 000 personnes en haute saison, Verbier est un haut lieu de la villégiature de luxe. La station compte parmi les plus beaux chalets des Alpes, des résidences secondaires de prestige et des hôtels de renommée mondiale comme le W Verbier ou le Experimental Chalet. Le village a su préserver son âme authentique avec ses chalets traditionnels en bois et pierre tout en développant une offre de loisirs et de bien-être de premier plan.
                </p>
                <p>
                  Verbier est également le théâtre d&apos;événements sportifs et culturels majeurs : le Verbier Festival, l&apos;un des plus grands festivals de musique classique au monde ; l&apos;Xtreme Verbier, finale du Freeride World Tour ; et le Patrouille des Glaciers, la plus célèbre course de ski alpinisme. Cette effervescence fait de Verbier une destination vivante toute l&apos;année, avec une forte demande en rénovation et aménagement d&apos;intérieur.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Verbier — Rénovation salle de bain et douche italienne</h3>
                <p>
                  L&apos;immobilier à Verbier se distingue par son extrême exigence. Les propriétaires investissent dans des finitions de très haut niveau : marbres italiens, pierres naturelles, mosaïques artisanales, carrelage grand format aux joints invisibles. Les salles de bain deviennent des espaces wellness privés avec hammam, sauna, baignoire îlot et douche panoramique. Chaque détail compte, de la robinetterie design aux éclairages indirects.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Société de carrelage à Verbier et dans les 4 Vallées</h3>
                <p>
                  Notre équipe d&apos;artisans carreleurs intervient à Verbier et dans les communes des 4 Vallées : Nendaz, Veysonnaz, Hérémence, La Tzoumaz. On connaît les accès en montagne, les livraisons en altitude, et les attentes d&apos;une clientèle internationale. On travaille discret, on livre propre, et les joints sont droits.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/verbier-realisation.jpg"
                  alt="Réalisation carrelage Verbier"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">3 000</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants permanents</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">1500 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">48h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Confidentiel</p>
                  <p className="text-xs text-stone-500 mt-1">Devis sur mesure</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Verbier</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis confidentiel à Verbier</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message, on vient vous voir à Verbier. On discute de votre projet avec discrétion, et on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Verbier</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            Dans les 4 Vallées, les matériaux doivent résister. Verbier, Nendaz, Veysonnaz, La Tzoumaz — on connaît les accès, les livraisons en altitude, et les attentes d'une clientèle internationale. On travaille discret et on livre propre.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis à Verbier
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Verbier"
        faqs={[
          {
            question: "Proposez-vous des finitions haut de gamme à Verbier ?",
            answer: "Oui, c'est notre cœur de métier à Verbier. On travaille avec du marbre italien, de la pierre naturelle, des mosaïques artisanales et des grands formats XXL. Les joints sont parfaitement alignés, les finitions sont impeccables, et le résultat correspond aux attentes d'une clientèle internationale exigeante."
          },
          {
            question: "Travaillez-vous discrètement dans les résidences privées ?",
            answer: "Absolument. À Verbier, on travaille régulièrement dans des résidences privées et des chalets de luxe. On respecte la confidentialité de nos clients, on arrive avec du matériel propre, et on protège les espaces pendant le chantier. La discrétion fait partie de notre façon de travailler."
          },
          {
            question: "Quels matériaux résistent au climat extrême de Verbier ?",
            answer: "À 1 500 mètres dans les 4 Vallées, le climat est extrême. On utilise des grès cérame de qualité supérieure, des pierres naturelles traitées, et des matériaux spécifiquement testés pour la résistance au gel. Pour les terrasses extérieures, on choisit des carrelages antidérapants R12 minimum."
          },
          {
            question: "Faites-vous des hammams et des spas privés à Verbier ?",
            answer: "Oui, on réalise des installations wellness complètes : hammam, douche hammam, baignoire en pierre, sauna, et robinetterie design. L'étanchéité est primordiale dans ces espaces, et on la réalise avec des membranes spécifiques et un savoir-faire éprouvé."
          },
          {
            question: "Intervenez-vous dans les 4 Vallées entières ?",
            answer: "Oui, on intervient à Verbier et dans tout le domaine des 4 Vallées : Nendaz, Veysonnaz, Hérémence, La Tzoumaz. On connaît les accès, les livraisons en altitude, et les particularités de chaque station. On planifie chaque chantier en fonction des contraintes logistiques locales."
          },
          {
            question: "Quel est le délai pour un projet de carrelage à Verbier ?",
            answer: "Le délai dépend de la complexité du projet et de la disponibilité des matériaux choisis. Pour un carrelage standard, comptez 1 à 2 semaines. Pour un projet luxe avec matériaux sur commande, cela peut prendre 3 à 6 semaines. On établit un planning précis dès le devis et on s'y tient."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
